import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import Switch from '../../../base/ui/components/web/Switch';
import AbstractMuteEveryoneDialog, { abstractMapStateToProps } from '../AbstractMuteEveryoneDialog';
import { isMobileBrowser } from "../../../base/environment/utils";
/**
 * A React Component with the contents for a dialog that asks for confirmation
 * from the user before muting all remote participants.
 *
 * @augments AbstractMuteEveryoneDialog
 */
class MuteEveryoneDialog extends AbstractMuteEveryoneDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const isMobile = isMobileBrowser();
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.muteParticipantButton' }, onSubmit: this._onSubmit, hideCloseButton: true, title: this.props.title, className: 'mute-everyone-video-dialog-container', classNameHeader: 'mute-everyone-video-header-dialog', classNameContent: 'mute-everyone-video-content-dialog', classNameFooter: 'mute-everyone-video-footer-dialog' },
            React.createElement("div", { className: 'mute-dialog' },
                React.createElement("div", { className: `mute-dialog-text${isMobile ? ' is-mobile' : ''}` }, this.state.content),
                this.props.isModerationSupported && this.props.exclude.length === 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: `control-row${isMobile ? ' is-mobile' : ''}` },
                        React.createElement("div", { className: `control-row-container${isMobile ? ' is-mobile' : ''}` },
                            React.createElement("label", { htmlFor: 'moderation-switch', className: isMobile ? ' is-mobile' : '' }, this.props.t('dialog.moderationAudioLabel')),
                            React.createElement(Switch, { checked: !this.state.audioModerationEnabled, id: 'moderation-switch', onChange: this._onToggleModeration }))))))));
    }
}
export default translate(connect(abstractMapStateToProps)(MuteEveryoneDialog));
